import RoofShapeOther from './../../../../assets/icons/parameters/default/other.svg';
import RoofShapeFlat from './../../../../assets/icons/parameters/family_house/roofShape-flat.svg';
import RoofShapeHalfHip from './../../../../assets/icons/parameters/family_house/roofShape-half-hip.svg';
import RoofShapeHip from './../../../../assets/icons/parameters/family_house/roofShape-hip.svg';
import RoofShapeMansard from './../../../../assets/icons/parameters/family_house/roofShape-mansard.svg';
import RoofShapeMonoPitched from './../../../../assets/icons/parameters/family_house/roofShape-mono-pitched.svg';
import RoofShapePyramid from './../../../../assets/icons/parameters/family_house/roofShape-pyramid.svg';
import RoofShapeSaddleWithDormers from './../../../../assets/icons/parameters/family_house/roofShape-saddle-with-dormers.svg';
import RoofShapeSaddle from './../../../../assets/icons/parameters/family_house/roofShape-saddle.svg';

export default {
    'roofShape-flat': RoofShapeFlat,
    'roofShape-half_hip': RoofShapeHalfHip,
    'roofShape-hip': RoofShapeHip,
    'roofShape-mansard': RoofShapeMansard,
    'roofShape-mono_pitched': RoofShapeMonoPitched,
    'roofShape-other': RoofShapeOther,
    'roofShape-pyramid': RoofShapePyramid,
    'roofShape-saddle': RoofShapeSaddle,
    'roofShape-saddle_with_dormers': RoofShapeSaddleWithDormers,
};
